export enum TableFilterTypeProps {
  DATEPICKER = 'datepicker',
  DATEPICKER_RANGE = 'datepicker-range',
  TEXT = 'text',
  DROPDOWN = 'dropdown'
}
